export default "__VITE_ASSET__3b5c59b8__"